var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection2ItemBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 58,
    viewBox: "0 0 97 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.877 7.80108L1 55H52.6098C55.1218 54.9995 57.5918 54.374 59.7838 53.1833C61.9758 51.9927 63.8167 50.2766 65.1306 48.1989L95 1H43.3978C40.8857 1.00053 38.4157 1.62599 36.2237 2.81665C34.0317 4.00732 32.1908 5.72342 30.877 7.80108V7.80108Z",
    stroke: "url(#paint0_linear_911_354)",
    strokeOpacity: 0.8,
    strokeMiterlimit: 10,
    strokeDasharray: "3 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3641 10.3566L2.49463 57.5555H54.0969C56.6081 57.5551 59.0773 56.9304 61.2691 55.7411C63.461 54.5519 65.3023 52.8376 66.6177 50.7618L96.4946 3.55554H44.8849C42.3728 3.55607 39.9028 4.18153 37.7108 5.37219C35.5188 6.56286 33.678 8.27896 32.3641 10.3566Z",
    fill: "#323232"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_911_354",
    x1: 114.052,
    y1: 28,
    x2: 31.6296,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781D95",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6E1D92",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#521E89",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#261F7A",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152075"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2ItemBackground);
export default __webpack_public_path__ + "static/media/section2itemBackground.8882eb69c77e215ffa6b02d49a0e6c80.svg";
export { ForwardRef as ReactComponent };